import React from 'react'
import { t } from 'ttag'

import { JobPositionModal } from 'components/modals/common/JobPositionModal/JobPositionModal'

import { useJobPositionModal } from 'components/modals/common/JobPositionModal/hooks'

type PositionManagementModalProps = {
  template?: any
  onBack?: () => void
  onCancel: () => void
  onClose: () => void
  onConfirm: (data: any, callbacks: any) => unknown
  isOpen: boolean
  isStandalone?: boolean
}

export const PositionManagementModal = ({
  template,
  onBack,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
  isStandalone = true,
}: PositionManagementModalProps) => {
  const { state, handlers } = useJobPositionModal(
    { template, isPositionManagement: true, isOpen },
    { onBack, onCancel, onClose, onConfirm },
  )

  const { activeTab, tab, tabs, isConfirmationOpen, isFirstStep, isLastStep } =
    state
  const {
    handleBack,
    handleCancel,
    handleClose,
    handleConfirm,
    handleConfirmationClose,
    handleConfirmationConfirm,
    handleTab,
  } = handlers

  return (
    <JobPositionModal
      title={template ? t`Edit job` : t`Create job`}
      onBack={isStandalone ? (!isFirstStep ? handleBack : null) : handleBack}
      onCancel={handleCancel}
      onClose={handleClose}
      onConfirm={handleConfirm}
      onConfirmationClose={handleConfirmationClose}
      onConfirmationConfirm={handleConfirmationConfirm}
      onTab={handleTab}
      {...{
        activeTab,
        tab,
        tabs,
        isConfirmationOpen,
        isLastStep,
        isOpen,
      }}
    />
  )
}
